<template>
  <div class="enterprise-cell-container">
    <div class="name">{{ detail.cusName || ' ' }}</div>
    <div class="uniqueCode" v-if="detail.type==0">统一社会信用代码：{{ detail.creditNo || ' ' }}</div>
    <div class="uniqueCode" v-else>身份证号码：{{ detail.idCode || ' ' }}</div>
    <div class="creditNo" v-if="detail.type==0">法定代表人：{{ detail.legalName || ' ' }}</div>
  </div>
</template>

<script>
export default {
  name: "enterpriseCell",
  props: ['detail'],
}
</script>

<style scoped lang="less">
.enterprise-cell-container {
  margin-bottom: 20px;
  .name {
    font-size: 13px;
    font-weight: 400;
    color: #3F3F3F;
  }
  .uniqueCode, .creditNo {
    font-size: 10px;
    font-weight: 400;
    color: #9A9A9A;
    margin-top: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/marketCenter/enterpriseCell.vue